var React = require('react');

function Linked (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M20 19.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14c0-1.252-.561-2-1.5-2s-1.5.748-1.5 2v5.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.314C13.65 9.306 14.416 9 15.5 9c2.733 0 4.5 1.962 4.5 5v5.5zM6 8c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm2 11.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v10zM21 1H3c-1.103 0-2 .897-2 2v18c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2V3c0-1.103-.897-2-2-2z"}));
}

Linked.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Linked;

Linked.default = Linked;
